<script>
import { mapActions } from 'vuex';

import request from '@/services/request';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {

    components: {
        DatePicker,
    },

    props: {

        prop_edit: {
            default: true,
        }

    },

    data() {

        return {

            form: {
                contract_dues_id: '',
                id: '',
                date: '',
                pdf: '',
                xml: '',
                comment: '',
                invoice_number: '',
            },

            errors: {},

            load: false,

            xml: '',
            pdf: '',

            xmlName: '',
            pdfName: '',

            send: false,

        }

    },

    computed: {

        isEditMode() {
            return !!this.form.id;
        },

        modalTitle() {
            return this.isEditMode
                ? 'Editar factura'
                : 'Registrar factura';
        },

        modalSubtitle() {
            return this.isEditMode
                ? 'Actualiza la información o reemplaza los archivos de la factura.'
                : 'Captura los datos y adjunta los documentos correspondientes.';
        }

    },

    methods: {

        handleFileChange(event, type) {

            const file = event.target.files[0];

            if (!file) {
                return;
            }

            if (type === 'xml') {

                this.form.xml = file;
                this.xmlName = file.name;

            }

            if (type === 'pdf') {

                this.form.pdf = file;
                this.pdfName = file.name;

            }

        },


        async handleSubmit() {

            if (this.send) {
                return;
            }

            this.send = true;

            this.errors = {};

            const formData = new FormData();

            formData.append(
                'contract_dues_id',
                this.form.contract_dues_id
            );

            formData.append(
                'id',
                this.form.id
            );

            formData.append(
                'date',
                this.form.date
            );

            formData.append(
                'pdf',
                this.form.pdf
            );

            formData.append(
                'xml',
                this.form.xml
            );

            formData.append(
                'comment',
                this.form.comment
            );

            formData.append(
                'invoice_number',
                this.form.invoice_number
            );


            let _endpoint = '/dues_bill';


            if (this.form.id !== '') {

                _endpoint =
                    `/dues_bill/${this.form.id}`;

                formData.append(
                    '_method',
                    'PUT'
                );

            }


            try {

                const response =
                    await request.postMedia(
                        _endpoint,
                        formData
                    );


                Event.$emit(
                    'event-show-loadBillFormDebts'
                );


                this.successNotification(
                    response.data.message
                );


                this.resetForm();

            } catch (error) {

                this.errors =
                    await this.errorNotification(error);

            } finally {

                this.send = false;

            }

        },


        resetForm() {

            this.form = {

                contract_dues_id: '',
                id: '',
                date: '',
                pdf: '',
                xml: '',
                comment: '',
                invoice_number: '',

            };


            this.errors = {};

            this.pdf = '';
            this.xml = '';

            this.pdfName = '';
            this.xmlName = '';

            this.send = false;
            this.load = false;


            if (this.$refs.pdfFile) {
                this.$refs.pdfFile.value = '';
            }

            if (this.$refs.xmlFile) {
                this.$refs.xmlFile.value = '';
            }


            this.$modal.hide(
                'addCreateBillFormDebt'
            );

        },


        getFileName(path) {

            if (!path) {
                return '';
            }

            const parts =
                String(path).split('/');

            return parts[
                parts.length - 1
            ];

        },


        ...mapActions({

            errorNotification:
                'alert/error',

            successNotification:
                'alert/success',

        })

    },


    created() {

        Event.$on(
            "event-show-addCreateBillFormDebts",
            (id, data = {}) => {

                this.load = true;

                this.errors = {};

                this.$modal.show(
                    'addCreateBillFormDebt'
                );


                this.form.contract_dues_id =
                    id;


                if (data.id) {

                    this.form.id =
                        data.id;

                    this.form.date =
                        data.date;

                    this.pdf =
                        data.pdf || '';

                    this.xml =
                        data.xml || '';

                    this.form.invoice_number =
                        data.invoice_number || '';

                    this.form.comment =
                        data.comment || '';

                }


                this.load = false;

            }
        );

    },


    watch: {
    }

}
</script>


<template>

    <modal
        name="addCreateBillFormDebt"
        :width="'92%'"
        :maxWidth="640"
        :height="'auto'"
        :adaptive="true"
        :scrollable="true"
        :click-to-close="false"
    >

        <form
            class="bill-form"
            @submit.prevent="handleSubmit"
        >

            <!-- =====================================================
                HEADER
            ====================================================== -->
            <div class="form-header">

                <div class="form-header__content">

                    <div class="form-header__icon">

                        <i
                            v-if="isEditMode"
                            class="fa-solid fa-file-pen"
                        ></i>

                        <i
                            v-else
                            class="fa-solid fa-file-circle-plus"
                        ></i>

                    </div>


                    <div>

                        <h5 class="form-header__title">
                            {{ modalTitle }}
                        </h5>

                        <p class="form-header__subtitle">
                            {{ modalSubtitle }}
                        </p>

                    </div>

                </div>


                <button
                    type="button"
                    class="form-close"
                    title="Cerrar"
                    @click="resetForm()"
                >

                    <i class="fa-solid fa-xmark"></i>

                </button>

            </div>


            <!-- =====================================================
                BODY
            ====================================================== -->
            <div class="form-body">


                <!-- LOADING -->
                <div
                    v-if="load"
                    class="loading-state"
                >

                    <i
                        class="fa-solid
                        fa-circle-notch
                        fa-spin"
                    ></i>

                    <span>
                        Cargando información...
                    </span>

                </div>


                <template v-else>


                    <!-- =================================================
                        DATOS GENERALES
                    ================================================== -->
                    <section class="form-section">

                        <div class="section-header">

                            <div class="section-number">
                                1
                            </div>

                            <div>

                                <h6 class="section-title">
                                    Datos de la factura
                                </h6>

                                <p class="section-description">
                                    Captura la fecha y el número
                                    correspondiente al documento.
                                </p>

                            </div>

                        </div>


                        <div class="form-grid">


                            <!-- FECHA -->
                            <div class="form-group">

                                <label class="field-label">

                                    Fecha

                                    <span class="required-mark">
                                        *
                                    </span>

                                </label>


                                <date-picker
                                    v-model="form.date"
                                    :disabled="!prop_edit"
                                    valueType="format"
                                    format="YYYY-MM-DD"
                                    :clearable="false"
                                    class="date-picker-field"
                                />


                                <div
                                    v-if="errors && errors.date"
                                    class="field-error"
                                >

                                    <i
                                        class="fa-solid
                                        fa-circle-exclamation"
                                    ></i>

                                    {{ errors.date[0] }}

                                </div>

                            </div>


                            <!-- NUMERO -->
                            <div class="form-group">

                                <label class="field-label">

                                    Número de factura

                                    <span class="required-mark">
                                        *
                                    </span>

                                </label>


                                <div class="input-icon">

                                    <span class="input-icon__icon">

                                        <i
                                            class="fa-solid
                                            fa-hashtag"
                                        ></i>

                                    </span>


                                    <input
                                        v-model="form.invoice_number"
                                        type="text"
                                        class="
                                            form-control
                                            input-icon__field
                                        "
                                        :class="{
                                            'is-invalid':
                                                errors &&
                                                errors.invoice_number
                                        }"
                                        :disabled="!prop_edit"
                                        placeholder="Ej. FAC-000123"
                                    >

                                </div>


                                <div
                                    v-if="
                                        errors &&
                                        errors.invoice_number
                                    "
                                    class="field-error"
                                >

                                    <i
                                        class="fa-solid
                                        fa-circle-exclamation"
                                    ></i>

                                    {{
                                        errors.invoice_number[0]
                                    }}

                                </div>

                            </div>

                        </div>

                    </section>



                    <!-- =================================================
                        DOCUMENTOS
                    ================================================== -->
                    <section class="form-section">

                        <div class="section-header">

                            <div class="section-number">
                                2
                            </div>

                            <div>

                                <h6 class="section-title">
                                    Documentos fiscales
                                </h6>

                                <p class="section-description">
                                    Adjunta los archivos PDF y XML
                                    correspondientes a la factura.
                                </p>

                            </div>

                        </div>


                        <div class="files-grid">


                            <!-- =========================================
                                PDF
                            ========================================== -->
                            <div class="file-field">

                                <div class="file-field__header">

                                    <div>

                                        <span class="file-field__title">
                                            Archivo PDF
                                        </span>

                                        <small>
                                            Documento visual de la factura
                                        </small>

                                    </div>


                                    <span
                                        class="
                                            file-type-badge
                                            file-type-badge--pdf
                                        "
                                    >
                                        PDF
                                    </span>

                                </div>


                                <label
                                    for="bill-pdf-file"
                                    class="file-uploader"
                                    :class="{
                                        'file-uploader--selected':
                                            pdfName,
                                        'file-uploader--disabled':
                                            !prop_edit
                                    }"
                                >

                                    <input
                                        id="bill-pdf-file"
                                        ref="pdfFile"
                                        type="file"
                                        :disabled="!prop_edit"
                                        accept="application/pdf"
                                        @change="
                                            handleFileChange(
                                                $event,
                                                'pdf'
                                            )
                                        "
                                    >


                                    <span class="file-uploader__icon">

                                        <i
                                            v-if="pdfName"
                                            class="
                                                fa-solid
                                                fa-circle-check
                                            "
                                        ></i>

                                        <i
                                            v-else
                                            class="
                                                fa-solid
                                                fa-cloud-arrow-up
                                            "
                                        ></i>

                                    </span>


                                    <span
                                        class="file-uploader__content"
                                    >

                                        <strong v-if="pdfName">
                                            {{ pdfName }}
                                        </strong>

                                        <strong v-else>
                                            Seleccionar archivo PDF
                                        </strong>


                                        <small v-if="pdfName">
                                            Archivo listo para guardar
                                        </small>

                                        <small v-else>
                                            Haz clic para seleccionar
                                        </small>

                                    </span>

                                </label>


                                <!-- ARCHIVO ACTUAL -->
                                <div
                                    v-if="pdf"
                                    class="current-file"
                                >

                                    <div class="current-file__info">

                                        <div
                                            class="
                                                current-file__icon
                                                current-file__icon--pdf
                                            "
                                        >

                                            <i
                                                class="
                                                    fa-regular
                                                    fa-file-pdf
                                                "
                                            ></i>

                                        </div>


                                        <div>

                                            <small>
                                                Archivo actual
                                            </small>

                                            <strong>
                                                {{
                                                    getFileName(pdf)
                                                }}
                                            </strong>

                                        </div>

                                    </div>


                                    <a
                                        :href="
                                            `${globalUrlFiles}${pdf}`
                                        "
                                        target="_blank"
                                        class="current-file__button"
                                        title="Ver PDF"
                                    >

                                        <i
                                            class="
                                                fa-solid
                                                fa-arrow-up-right-from-square
                                            "
                                        ></i>

                                        Ver

                                    </a>

                                </div>


                                <div
                                    v-if="errors && errors.pdf"
                                    class="field-error"
                                >

                                    <i
                                        class="
                                            fa-solid
                                            fa-circle-exclamation
                                        "
                                    ></i>

                                    {{ errors.pdf[0] }}

                                </div>

                            </div>



                            <!-- =========================================
                                XML
                            ========================================== -->
                            <div class="file-field">

                                <div class="file-field__header">

                                    <div>

                                        <span class="file-field__title">
                                            Archivo XML
                                        </span>

                                        <small>
                                            Comprobante fiscal electrónico
                                        </small>

                                    </div>


                                    <span
                                        class="
                                            file-type-badge
                                            file-type-badge--xml
                                        "
                                    >
                                        XML
                                    </span>

                                </div>


                                <label
                                    for="bill-xml-file"
                                    class="file-uploader"
                                    :class="{
                                        'file-uploader--selected':
                                            xmlName,
                                        'file-uploader--disabled':
                                            !prop_edit
                                    }"
                                >

                                    <input
                                        id="bill-xml-file"
                                        ref="xmlFile"
                                        type="file"
                                        :disabled="!prop_edit"
                                        accept=".xml"
                                        @change="
                                            handleFileChange(
                                                $event,
                                                'xml'
                                            )
                                        "
                                    >


                                    <span class="file-uploader__icon">

                                        <i
                                            v-if="xmlName"
                                            class="
                                                fa-solid
                                                fa-circle-check
                                            "
                                        ></i>

                                        <i
                                            v-else
                                            class="
                                                fa-solid
                                                fa-cloud-arrow-up
                                            "
                                        ></i>

                                    </span>


                                    <span
                                        class="file-uploader__content"
                                    >

                                        <strong v-if="xmlName">
                                            {{ xmlName }}
                                        </strong>

                                        <strong v-else>
                                            Seleccionar archivo XML
                                        </strong>


                                        <small v-if="xmlName">
                                            Archivo listo para guardar
                                        </small>

                                        <small v-else>
                                            Haz clic para seleccionar
                                        </small>

                                    </span>

                                </label>


                                <!-- ARCHIVO ACTUAL -->
                                <div
                                    v-if="xml"
                                    class="current-file"
                                >

                                    <div class="current-file__info">

                                        <div
                                            class="
                                                current-file__icon
                                                current-file__icon--xml
                                            "
                                        >

                                            <i
                                                class="
                                                    fa-solid
                                                    fa-code
                                                "
                                            ></i>

                                        </div>


                                        <div>

                                            <small>
                                                Archivo actual
                                            </small>

                                            <strong>
                                                {{
                                                    getFileName(xml)
                                                }}
                                            </strong>

                                        </div>

                                    </div>


                                    <a
                                        :href="
                                            `${globalUrlFiles}${xml}`
                                        "
                                        target="_blank"
                                        class="current-file__button"
                                        title="Ver XML"
                                    >

                                        <i
                                            class="
                                                fa-solid
                                                fa-arrow-up-right-from-square
                                            "
                                        ></i>

                                        Ver

                                    </a>

                                </div>


                                <div
                                    v-if="errors && errors.xml"
                                    class="field-error"
                                >

                                    <i
                                        class="
                                            fa-solid
                                            fa-circle-exclamation
                                        "
                                    ></i>

                                    {{ errors.xml[0] }}

                                </div>

                            </div>

                        </div>

                    </section>



                    <!-- =================================================
                        COMENTARIO
                    ================================================== -->
                    <section class="form-section">

                        <div class="section-header">

                            <div class="section-number">
                                3
                            </div>

                            <div>

                                <h6 class="section-title">
                                    Comentarios
                                </h6>

                                <p class="section-description">
                                    Agrega información adicional
                                    relacionada con esta factura.
                                </p>

                            </div>

                        </div>


                        <div class="form-group mb-0">

                            <label class="field-label">
                                Comentario
                            </label>


                            <textarea
                                v-model="form.comment"
                                rows="3"
                                class="form-control comment-field"
                                :disabled="!prop_edit"
                                placeholder="
                                    Escribe una observación
                                    o comentario adicional...
                                "
                            ></textarea>


                            <small class="field-help">
                                Este comentario será visible
                                en el listado de facturas.
                            </small>


                            <div
                                v-if="errors && errors.comment"
                                class="field-error"
                            >

                                <i
                                    class="
                                        fa-solid
                                        fa-circle-exclamation
                                    "
                                ></i>

                                {{ errors.comment[0] }}

                            </div>

                        </div>

                    </section>

                </template>

            </div>


            <!-- =====================================================
                FOOTER
            ====================================================== -->
            <div class="form-footer">

                <button
                    type="button"
                    class="
                        btn
                        btn-light
                        footer-button
                    "
                    :disabled="send"
                    @click="resetForm()"
                >

                    Cancelar

                </button>


                <button
                    v-if="prop_edit"
                    type="submit"
                    class="
                        btn
                        btn-success
                        footer-button
                        footer-button--save
                    "
                    :disabled="send || load"
                >

                    <i
                        v-if="send"
                        class="
                            fa-solid
                            fa-circle-notch
                            fa-spin
                        "
                    ></i>

                    <i
                        v-else
                        class="fa-solid fa-floppy-disk"
                    ></i>


                    {{
                        send
                            ? 'Guardando...'
                            : (
                                isEditMode
                                    ? 'Guardar cambios'
                                    : 'Guardar factura'
                            )
                    }}

                </button>

            </div>

        </form>

    </modal>

</template>


<style scoped>

.bill-form {

    --primary: #5672a5;
    --primary-dark: #304d7d;
    --primary-soft: #eef3fb;

    --success: #269b74;
    --success-soft: #eaf8f3;

    --warning: #d99b24;
    --warning-soft: #fff8e8;

    --danger: #d84d5d;
    --danger-soft: #fff0f2;

    --border: #dfe5ee;

    --surface: #ffffff;
    --background: #f5f7fb;

    --text: #1f2937;
    --muted: #6b7280;

    background: var(--background);

    color: var(--text);

}


/* ==============================================================
   HEADER
============================================================== */

.form-header {

    align-items: center;

    background: linear-gradient(
        135deg,
        var(--primary-dark),
        var(--primary)
    );

    color: #ffffff;

    display: flex;

    justify-content: space-between;

    padding: 18px 22px;

}


.form-header__content {

    align-items: center;

    display: flex;

    gap: 14px;

}


.form-header__icon {

    align-items: center;

    background:
        rgba(255, 255, 255, 0.15);

    border:
        1px solid rgba(255, 255, 255, 0.2);

    border-radius: 12px;

    display: flex;

    font-size: 22px;

    height: 46px;

    justify-content: center;

    width: 46px;

}


.form-header__title {

    font-size: 18px;

    font-weight: 700;

    margin: 0;

}


.form-header__subtitle {

    color:
        rgba(255, 255, 255, 0.78);

    font-size: 12px;

    margin: 3px 0 0;

}


.form-close {

    align-items: center;

    background:
        rgba(255, 255, 255, 0.12);

    border: 0;

    border-radius: 50%;

    color: #ffffff;

    cursor: pointer;

    display: flex;

    height: 36px;

    justify-content: center;

    transition: 0.2s ease;

    width: 36px;

}


.form-close:hover {

    background:
        rgba(255, 255, 255, 0.24);

    transform: rotate(90deg);

}


/* ==============================================================
   BODY
============================================================== */

.form-body {

    max-height:
        calc(100vh - 185px);

    overflow-y: auto;

    padding: 20px;

}


/* ==============================================================
   SECTION
============================================================== */

.form-section {

    background:
        var(--surface);

    border:
        1px solid var(--border);

    border-radius: 12px;

    box-shadow:
        0 3px 10px
        rgba(15, 23, 42, 0.04);

    margin-bottom: 16px;

    padding: 18px;

}


.form-section:last-child {

    margin-bottom: 0;

}


.section-header {

    align-items: flex-start;

    display: flex;

    gap: 12px;

    margin-bottom: 17px;

}


.section-number {

    align-items: center;

    background:
        var(--primary-soft);

    border-radius: 50%;

    color:
        var(--primary-dark);

    display: flex;

    flex: 0 0 auto;

    font-size: 13px;

    font-weight: 700;

    height: 30px;

    justify-content: center;

    width: 30px;

}


.section-title {

    color:
        var(--text);

    font-size: 15px;

    font-weight: 700;

    margin: 1px 0 3px;

}


.section-description {

    color:
        var(--muted);

    font-size: 11px;

    margin: 0;

}


/* ==============================================================
   FORM
============================================================== */

.form-grid {

    display: grid;

    gap: 16px;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

}


.form-group {

    margin-bottom: 0;

}


.field-label {

    color: #374151;

    display: block;

    font-size: 12px;

    font-weight: 600;

    margin-bottom: 6px;

}


.required-mark {

    color:
        var(--danger);

}


.field-help {

    color:
        var(--muted);

    display: block;

    font-size: 10px;

    margin-top: 5px;

}


.field-error {

    align-items: center;

    color:
        var(--danger);

    display: flex;

    font-size: 10px;

    gap: 5px;

    margin-top: 5px;

}


.form-control {

    border-color: #d5dce6;

    border-radius: 7px;

    font-size: 12px;

    min-height: 38px;

}


.form-control:focus {

    border-color:
        var(--primary);

    box-shadow:
        0 0 0 3px
        rgba(86, 114, 165, 0.12);

}


.form-control:disabled {

    background: #f6f7f9;

    color:
        var(--muted);

}


.is-invalid {

    border-color:
        var(--danger) !important;

}


/* ==============================================================
   DATE PICKER
============================================================== */

.date-picker-field {

    width: 100%;

}


.bill-form
::v-deep
.mx-datepicker {

    width: 100%;

}


.bill-form
::v-deep
.mx-input {

    border:
        1px solid #d5dce6;

    border-radius: 7px;

    box-shadow: none;

    font-size: 12px;

    height: 38px;

}


.bill-form
::v-deep
.mx-input:focus {

    border-color:
        var(--primary);

    box-shadow:
        0 0 0 3px
        rgba(86, 114, 165, 0.12);

}


/* ==============================================================
   INPUT ICON
============================================================== */

.input-icon {

    display: flex;

}


.input-icon__icon {

    align-items: center;

    background: #f3f5f8;

    border:
        1px solid #d5dce6;

    border-radius:
        7px 0 0 7px;

    color:
        var(--primary);

    display: flex;

    flex: 0 0 auto;

    justify-content: center;

    width: 38px;

}


.input-icon__field {

    border-left: 0;

    border-radius:
        0 7px 7px 0;

}


/* ==============================================================
   FILES
============================================================== */

.files-grid {

    display: grid;

    gap: 16px;

    grid-template-columns:
        repeat(2, minmax(0, 1fr));

}


.file-field {

    min-width: 0;

}


.file-field__header {

    align-items: center;

    display: flex;

    justify-content:
        space-between;

    margin-bottom: 8px;

}


.file-field__title {

    color: #374151;

    display: block;

    font-size: 12px;

    font-weight: 600;

}


.file-field__header small {

    color:
        var(--muted);

    display: block;

    font-size: 9px;

    margin-top: 2px;

}


.file-type-badge {

    border-radius: 6px;

    font-size: 9px;

    font-weight: 700;

    padding: 4px 7px;

}


.file-type-badge--pdf {

    background:
        var(--danger-soft);

    color:
        var(--danger);

}


.file-type-badge--xml {

    background:
        var(--success-soft);

    color:
        var(--success);

}


/* UPLOAD */

.file-uploader {

    align-items: center;

    background: #fafbfd;

    border:
        1px dashed #cbd5e1;

    border-radius: 10px;

    cursor: pointer;

    display: flex;

    gap: 11px;

    margin: 0;

    min-height: 78px;

    padding: 13px;

    transition: 0.2s ease;

}


.file-uploader:hover {

    background:
        var(--primary-soft);

    border-color:
        var(--primary);

}


.file-uploader input {

    height: 1px;

    opacity: 0;

    position: absolute;

    width: 1px;

}


.file-uploader--selected {

    background:
        var(--success-soft);

    border-color: #bcded2;

}


.file-uploader--disabled {

    cursor: not-allowed;

    opacity: 0.65;

}


.file-uploader__icon {

    align-items: center;

    background: #ffffff;

    border: 1px solid
        var(--border);

    border-radius: 9px;

    color:
        var(--primary);

    display: flex;

    flex: 0 0 auto;

    font-size: 17px;

    height: 40px;

    justify-content: center;

    width: 40px;

}


.file-uploader--selected
.file-uploader__icon {

    color:
        var(--success);

}


.file-uploader__content {

    display: flex;

    flex-direction: column;

    min-width: 0;

}


.file-uploader__content strong {

    color:
        var(--text);

    font-size: 11px;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

}


.file-uploader__content small {

    color:
        var(--muted);

    font-size: 9px;

    margin-top: 3px;

}


/* CURRENT FILE */

.current-file {

    align-items: center;

    background: #ffffff;

    border:
        1px solid var(--border);

    border-radius: 8px;

    display: flex;

    gap: 10px;

    justify-content:
        space-between;

    margin-top: 8px;

    padding: 8px 10px;

}


.current-file__info {

    align-items: center;

    display: flex;

    gap: 8px;

    min-width: 0;

}


.current-file__icon {

    align-items: center;

    border-radius: 7px;

    display: flex;

    flex: 0 0 auto;

    height: 32px;

    justify-content: center;

    width: 32px;

}


.current-file__icon--pdf {

    background:
        var(--danger-soft);

    color:
        var(--danger);

}


.current-file__icon--xml {

    background:
        var(--success-soft);

    color:
        var(--success);

}


.current-file__info small {

    color:
        var(--muted);

    display: block;

    font-size: 8px;

}


.current-file__info strong {

    color:
        var(--text);

    display: block;

    font-size: 10px;

    max-width: 190px;

    overflow: hidden;

    text-overflow: ellipsis;

    white-space: nowrap;

}


.current-file__button {

    align-items: center;

    background:
        var(--primary-soft);

    border-radius: 6px;

    color:
        var(--primary-dark);

    display: inline-flex;

    flex: 0 0 auto;

    font-size: 9px;

    font-weight: 700;

    gap: 5px;

    padding: 6px 8px;

    text-decoration: none !important;

}


.current-file__button:hover {

    background:
        var(--primary);

    color: #ffffff;

}


/* ==============================================================
   COMMENT
============================================================== */

.comment-field {

    min-height: 82px;

    resize: vertical;

}


/* ==============================================================
   LOADING
============================================================== */

.loading-state {

    align-items: center;

    color:
        var(--muted);

    display: flex;

    font-size: 12px;

    gap: 9px;

    justify-content: center;

    min-height: 220px;

}


.loading-state i {

    color:
        var(--primary);

    font-size: 20px;

}


/* ==============================================================
   FOOTER
============================================================== */

.form-footer {

    align-items: center;

    background: #ffffff;

    border-top:
        1px solid var(--border);

    display: flex;

    gap: 10px;

    justify-content: flex-end;

    padding: 14px 22px;

}


.footer-button {

    border-radius: 7px;

    font-size: 11px;

    min-width: 110px;

    padding: 8px 14px;

}


.footer-button--save {

    min-width: 155px;

}


.footer-button--save i {

    margin-right: 5px;

}


/* ==============================================================
   RESPONSIVE
============================================================== */

@media (max-width: 640px) {

    .form-body {

        padding: 14px;

    }


    .form-grid,
    .files-grid {

        grid-template-columns:
            1fr;

    }


    .form-header {

        padding: 15px;

    }


    .form-header__subtitle {

        display: none;

    }


    .form-section {

        padding: 15px;

    }


    .form-footer {

        flex-direction:
            column-reverse;

        padding: 12px 14px;

    }


    .footer-button {

        width: 100%;

    }


    .current-file__info strong {

        max-width: 160px;

    }

}

</style>